// extracted by mini-css-extract-plugin
export default {"workplaceLink":"Experience_workplaceLink__uJfLP","time":"Experience_time__zs5Dx","experienceSection":"Experience_experienceSection__riEUp"};